import React from 'react'
import { Container } from 'react-bootstrap';
import SideMenu from './SideMenu';
import Header from './Header';
 import { Outlet } from 'react-router-dom';

function MainPage() {
  return (
<div >
      <Container fluid style={{ margin: 0, padding: 0,   }} >
        <div>
          <Header />
        </div>

        <div style={{display: 'flex'}}>
            <SideMenu/>
            <Outlet />
         </div>
        
         
      </Container>
    </div>  
    
    )
}

export default MainPage